import {API_KEY_DEVELOPMENT} from "./environment"
export default function GET_API_KEY() {
    if (process.env.NODE_ENV === 'development') {
        return API_KEY_DEVELOPMENT
    } else {
        return localStorage.getItem('authToken')
    }
}
